var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVueRoute
    ? _c(
        "router-link",
        {
          class: _vm.classes,
          attrs: { to: _vm.link, target: "_parent" },
          on: { click: _vm.emitClick }
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "a",
        {
          class: _vm.classes,
          attrs: { href: _vm.link, target: "_parent" },
          on: { click: _vm.emitClick }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8eaaacfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eaaacfa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationRoute.vue
// module id = null
// module chunks = 